import { render, staticRenderFns } from "./CountryDetail.vue?vue&type=template&id=c44f7192&scoped=true&"
import script from "./CountryDetail.vue?vue&type=script&lang=js&"
export * from "./CountryDetail.vue?vue&type=script&lang=js&"
import style0 from "./CountryDetail.vue?vue&type=style&index=0&id=c44f7192&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c44f7192",
  null
  
)

export default component.exports